// Electric's Apple Business Manager reseller IDs.
// US has been in use since ABM launched; CA was added for FD-3475 (Canada storefront ABM enrollment).
export const US_ABM_RESELLER_ID = '16210800';
export const CA_ABM_RESELLER_ID = 'B55DE50';
